<div class="buttonblock">
  <ng-content></ng-content>
</div>
